import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { applyServiceWorkerUpdate } from '../serviceWorkerRegistration';

function PwaUpdatePrompt() {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handleUpdate = (event) => {
      setRegistration(event.detail);
    };

    window.addEventListener('nexohub:sw-update', handleUpdate);

    return () => {
      window.removeEventListener('nexohub:sw-update', handleUpdate);
    };
  }, []);

  if (!registration) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[100] mx-auto flex max-w-md items-center gap-3 rounded-lg border border-slate-200 bg-white p-3 shadow-xl">
      <div className="flex-1">
        <p className="text-sm font-semibold text-slate-900">Nueva version disponible</p>
        <p className="text-xs text-slate-500">Actualiza para usar la ultima version de NexoHub.</p>
      </div>
      <button
        type="button"
        onClick={() => applyServiceWorkerUpdate(registration)}
        className="inline-flex h-9 items-center gap-2 rounded-md bg-indigo-600 px-3 text-sm font-semibold text-white hover:bg-indigo-700"
      >
        <RefreshCw size={16} />
        Actualizar
      </button>
      <button
        type="button"
        aria-label="Cerrar"
        onClick={() => setRegistration(null)}
        className="inline-flex h-9 w-9 items-center justify-center rounded-md text-slate-500 hover:bg-slate-100 hover:text-slate-900"
      >
        <X size={16} />
      </button>
    </div>
  );
}

export default PwaUpdatePrompt;
